import { call, put, takeLatest } from 'redux-saga/effects';

import { getTypesOfLandUse } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const response = yield call(getTypesOfLandUse, action.payload);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* typesOfLandUseSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
